
export const initialState = {
    app: {
      maintenance: false,
    },
    lang: 'de',
    user: {
      sessionId: null,
      loggedIn: false,
      guest: true,
      userId: null,
      credits: 0,       // prepaid credits   
      totalCredits: 0,  // prepaid credits + license credits or 9999 for flat rate
      voucherCode: null,
      mail: null,
      settings: {
        pagesize: 25,
        reportRenderComments: true,
        reportIncludeGuide: true,
        reportTruncate: true,
        reportFormat: 'docx',
        reportLang: 'en',              // null: use user language
        showTooltips: true,
        maxPhraseDistance: 125,
        minRegionLength: 50,
        minSimilarity: 35,
        minSourceLength: 15, 
        scansPerDay: 1,
        maxMonitoringHits: 0,           // "Wikipedia-Filter"
        monitoringIgnoreOwn: true,      // Ignore duplicate content across own observed pages / domains
        monitoringIgnoreCites: false,    // Ignore content indicated as block quote or cite 
        useTextMonitoring: true       
      },
      license: {},
      activities: [],               // List of latest activities to be displayed in LatestActivityCard
      orders: []                    // List of orders of this user
    },
    checkout: {
      products: [],
      countries: [],
      paymentStep: 0,
      productId: null,
      paymentId: null,
      currency: "EUR",
      term: "yearly",
      education: {},
      file: {},                   // uploaded file info as rerieved by GetUploadedFileInfo()
      invoiceId: null,
      wizard: {
        step: 0,
        requiredCredits: 0,
        availableCreditsAfterCheckout: 0,
        requiredProductId: 0,
        uploadId: null,
      }
    },
    ui: {
      downloadReportDialogOpen: false,
      propertyBarVisible: true,
      languageMenuVisible: null,
      reportDisplayMode: 'merged',
      leftPanelVisible: true,
      plagCheckMenuExpanded: false,
      libraryMenuExpanded: false,
      monitoringMenuExpanded: false,
      toolsMenuExpanded: false,
      paymentDialogVisible: false,
      settingsDialogVisible: false,
      profileDialogVisible: false,
      autoAcceptSourcesDialogOpen: false,
      autoExcludeSourcesDialogOpen: false,
      pageName: 'home',
      redirect: false,
      error: '',
      filterPIdx: 0,
      confirmationDialog: {
        visible: false,
        payload: {},
      },
      logDialog: {
        visible: false,
        payload: {},
      },
      pasteDialog: {
        visible: false,
        payload: {},
      },
      fullScreenLoading: false,
      fullScreenLoadingText: null,
      permaLink: false,
      colors: [
        'rgba(239, 179, 196, 0.99)',
        'rgba(255, 191, 178, 0.99)',
        'rgba(255, 207, 159, 0.99)',
        'rgba(255, 227, 133, 0.99)',
        'rgba(216, 235, 177, 0.99)',
        'rgba(188, 233, 207, 0.99)',
        'rgba(168, 232, 228, 0.99)',
        'rgba(200, 221, 229, 0.99)',
        'rgba(209, 209, 220, 0.99)',
        'rgba(229, 197, 209, 0.99)'
      ],
      hoverAlpha: '0.5',
      showTextWithoutMarkup: false,            // show full text in report review (true) or skip without markings (false)
      showLinebreaks: false,                    // render linebreaks in test text and side-by-side views
      licenseView: 'usage',
      sourcesView: 'sources',               // toggle sources or statistics view
      statisticsType: 'kil',
      statisticsMode: 'md',
      textOverlayLoading: false,
      textOverlay: {
        kil: {
          order: 1,
          title: 'kiTypicity',
          colors: [{ r: 0, g: 225, b: 0 }, { r: 255, g: 255, b: 255 }, { r: 225, g: 0, b: 0 }],
          values: [25, 50, 75],
          labels: ['untypical', 'inconspicuous', 'typical']
        },
        fre: {
          order: 3,
          title: 'felshReadingEase',
          colors: [{ r: 225, g: 0, b: 0 }, { r: 255, g: 255, b: 0 }, { r: 0, g: 225, b: 0 }],
          values: [0, 50, 100],
          labels: ['hard', 'medium', 'easy']
        }, 
        gfi: {
          order: 4,
          title: 'gunningFogReadingEase',
          colors: [{ r: 0, g: 225, b: 0 }, { r: 255, g: 255, b: 0 }, { r: 222, g: 0, b: 0 }],
          values: [4, 10, 16],
          labels: ['easy', 'medium', 'hard']
        }, 
        wsf: {
          order: 2,
          title: 'viennaTextReadingEase',
          colors: [{ r: 0, g: 225, b: 0 }, { r: 255, g: 255, b: 0 }, { r: 222, g: 0, b: 0 }],
          values: [4, 10, 16],
          labels: ['easy', 'medium', 'hard']
        }, 
        default: {
          title: 'displayFilterLabel',
          colors: [{ r: 255, g: 255, b: 255 }, { r: 255, g: 255, b: 255 }, { r: 25, g: 25, b: 255 }],
          values: [0, 0, 100],
          labels: ['klein', 'mittel', 'groß']
        }
      },
    },
    licenseAdmin: {               // state of adminstered license, only valid for license admin users
      currentLicense: {},         // properties of adminstered license
      users: [],                  // users in this license, subject to license filter
      phases: [],                 // list of phases of this license
      userCount: 0,               // total number of users                
      usersFilter: {              // filter for users
        search: "",               // search user name
        license: "",              // sub license
        date: ""                  // date range    
      },
      usersPagination: {
        pageno: 1,
        sortdir: "asc",
        sortby: "mail",
      },
      subLicenses: [],            // subordinate licenses of the parent license
      chartData: {
        sets: [],
        title: ""
      }
    },
    // Report data
    reportsDashboard: [],                  // array of reports displayed in report overview
    reports: [],                  // array of reports displayed in report overview
    libraries: [],                  // array of libraries displayed in library overview
    latestReports: [],            // array of latest reports to be displayed in dashboard LatestPlagiairismChecksCard
    totalReportsNumber: 0,         // total number of reports (including not displayed ones)
    totalLibrariesNumber: 0,         // total number of libraries (including not displayed ones)
    activeReportId: null,         // id of currently selected report REDUNDANT
    activeLibraryId: null,         // id of currently selected library REDUNDANT
    reportId: "",                 // id of currently selected report REDUNDANT
    activeReport: {},             // currently active Report
    activeLibrary: {},             // currently active library
    reportMarkup: [],             // report markup of active report
    textOverlay: [],              // text overlay of active report
    overlayStatistics: [],        // overlay statistics of active report
    reportStatus: {},             // unknown
    selectedReportIds: [],        // ids of reports currently selected, e.g. in report overview table
    selectedLibraryIds: [],        // ids of libraries currently selected, e.g. in library overview table
    draftReport: {},              // draft report holding properties for new plagiairism check
    draftLibrary: {},              // draft report holding properties for new plagiairism check
    reportFilter: {               // active filter for report overview
      projectId: "",
      search: "",
      date: "",
      state: "",
      userId: "",
    },
    reportPagination: {           // pagination and sort order for report overview
      pageno: 1,
      sortdir: "desc",
      sortby: "Scheduled",
    },
    libraryFilter: {               // active filter for library overview
      projectId: "",
      search: "",
      date: "",
      state: "",
    },
    libraryPagination: {           // pagination and sort order for library overview
      pageno: 1,
      sortdir: "desc",
      sortby: "ProjectName",
    },
    librariesChangeNo: 0,           // change no for library overview used to easily check if libraries need to be updated
    reportsChangeNo: 0,           // change no for report overview used to easily check if reports need to be updated
    licenseUsersChangeNo: 0,           // change no for license user admin used to easily check if user table needs to be updated
    
    messageList: [],
    downloadReportIds: [],        // permalink ids(!) of reports that should be downloaded if user confirms in report download dialog

    sources: [],                  // list of sources of active report
    searchedSources: [],          // list of sources sorted and filtered by sourceFilter
    sourceFilter: {               // sort and order options for report sources
      onlineSource: true,
      librarySource: true,
      acceptedSource: true,
      suspiciousSource: true,
      excludedSource: false,
      duplicatedSource: false,
      searchTextValue: "",
      sortBy: 1,
      changeNo: 0
    },
    activeSource: {},       // currently active Source
    sourceMarkup: {},       // markup of active source as used for compare dialog

    toastrAlert: {
      type: "success",
      message: "",
      status: false
    },
    projects: [],                 // all projects of a user
    filteredProjects: [],                 // all projects of a user
    mapProjectId2ProjectIdx: {},
    
    
    mapReportId2ReportIdx: {},
    mapLibraryId2LibraryIdx: {},
    
    loadingSource: false,
    loadingSourceDetail: false,
    loadingReportDetail: false,
    loadingLibraryDetail: false,
    loadingSidebySideCompare: false,
    resetReport: [],
    reportSourceStatus: true,
    librarySourceStatus: true,
    reportStatusMessage: "null",

    
    newCheckSettings: {
      searchWeb: true,              // search in web sources
      searchLib: true,              // search in library sources
      searchInLibraryProjects: [],  // search only in specific library texts
      source: 'upload',             // overall source (one of 'upload', 'download', 'text', 'library')
      libraryTexts: [],             // check of library texts (relevant only if source == 'library')
      considerTags: true,           // consider PlagAware tags when downloading text for new plag check (relevant only if source == 'download')
      text: '',                     // test text (only relevant if source == 'text')
      revisionReportId: null,       // id of report if new check is a revision of an existing check
      changeNo: 0,                  // will be increased with every state change to easily track changes in useEffect()
      excludeUrlPatterns:[],        // 
      acceptUrlPatterns:[],
      excludeByWhitelist: true,
      acceptCitedUrls: true,
      addToLibrary: false
    },
    newTextSettings: {
      source: 'upload',
      text: '',
      changeNo: 0
    },
    uploadedFiles: [],              // list of uploaded files, used for new plag check and upload text to library
    uploadedFilesStatus: [],        // status of uploaded files as retrieved by GetUploadedFilesStatus()
    checkedOnlineSources: true,
    checkedLibrarySources: true,
    checkedExcludeSources: false,
    checkedAcceptSource: false,
    creditCosts: {
      words: 0,
      credits: 0,
      pages: 0,
      texts: 0
    },
    excludeSources: false,
    acceptSource: false,
    openInputUrlPopup: false,
    calculateCreditsData: {
      text: "",
      lib: 1,
      web: 1,
    },
    propertiesForm: {},
    newPlagCheck: {},
    
    activePanel:"uploadFiles",
    tagsCheckbox: false,
    performCheckLayout: 'list',
    
    selectedRow: [],
    //openConfirmationPopup: false,
    propertiesDataValue:{},
    reportStatisticsByProject: {},
    reportStatisticsByMonth: {},
    news: [],
    faqs: [],
    selectedProject: {},
    collusion: {
      sources: [],
      left: 0,
    },
    projectsChangeNo: 0,
    projectsFilterChangeNo: 0,
    draftProject: {},
    projectPagination: {
      sortdir: "asc",
      sortby: "Name",
    },
    projectFilter: {
      search: "",
    },
    openCreateProjectPopup: false,
};

